<template>
<div class="daily-template full-at-xs" >
  <div  :class="{'card--transparent': state}">
    <div class="card" :style="{'background-color': color}">
      <div class="row space-between flex-start">
        <h2 class="flex-1">{{habit.name}}</h2>
      </div>
      <div class="row space-between small-top">
        <actions text="Details" icon="info" @click="setState('details')" :active="state === 'details'"/>
        <actions text="Notes" icon="note_add" @click="setState('journal')" :active="state === 'journal'" />
      </div>
    </div>
    <div class="card information" v-if="state === 'details'">
      <week-btns class="small-top" :allow-edit="false" :week="habit.days_of_week" :color="color" />
      <div class="small-top">{{habit.description}}</div>
      <h2 :style='{"color": color}' class="small-top">How</h2>
      <div>{{habit.visualization}} </div>
      <h2 :style='{"color": color}'>
        Why this
      </h2>
      <div>
        {{habit.why}}
      </div>
    </div>

    <div class="card information" v-if="state === 'journal'">
      <!-- <week-btns :week="template." :color="color" /> -->
      <div v-if="loading">Loading...</div>
      <div v-if="!loading && notes.length == 0">
        {{client.first_name}} has not taken any notes.
      </div>
      <div v-else>
        <div v-for="note in notes" :key="note.id" class="note">
          <h4>{{note.title}}</h4>
          <div>{{note.text}}</div>
          <div class="divider"></div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import actions from "@/components/h-actions";
import weekBtns from "@/components/weekBtns";
// import dataStore from "@/services/api/store";
// import snackbar from "@/services/hubs/snackbar";
// import moment from "moment";
import store from "@/services/api/store";
// import rafflehub from "@/services/hubs/raffle";
// const CLIENT_STORE = "ClientHabits";

export default {
  components: { actions, weekBtns, },
  props: {habit: Object, client: Object },
  data() {
    return {
      state: "",
      loading: false,
      display: false,
      notes: [],
    };
  },
  methods: {
    setState(state) {
      if (state === this.state) {
        this.state = "";
        return;
      }
      this.state = state;
      if (state == "journal") {
        if (this.notes.length > 0) {
          return;
        }
        this.loading = true;
        store
          .findAll("CoachClientsNotes", {habit: this.habit.id})
          .then(notes => {
            this.notes = notes;
          })
          .finally(() => {
            this.loading = false;
          });
      };
    }
  },
  computed: {
    displayTransparent() {
      return this.displayDetails || this.takeNote;
    },
    color() {
      return this.habit.color;
    },
  }
}
</script>

<style lang="less" scoped>
@import "../../../../styles/screenSizes";
.daily-template {
  width: 32%;
  margin: 10px 5px;

  @media (max-width: @xs) {
    width: 100%;
  }

  @media (max-width: @md) {
    width: 48%;
    margin: 10px 0px;
  }
}
</style>
